import { computed, Directive, effect, ElementRef, inject, input, OnInit } from '@angular/core';

@Directive({
    selector: '[ngbControl]',
    host: {
        '[class.form-check-input]': 'true === formCheckInput',
        '[class.form-control]': 'true === formControlClass',
    },
})
export class NgbControlDirective implements OnInit {
    formCheckInput = false;
    formControlClass = true;
    label = input<string|null>(null);
    ngbControl = input<string>();
    isCustom = computed(() => this.ngbControl().toLowerCase().includes('custom'));
    protected isReadonly = computed(() => this.ngbControl().toLowerCase().includes('readonly'));

    elem = inject(ElementRef);

    constructor() {
        effect(() => this.makeReadonly());
    }

    ngOnInit(): void {
        if (
            !this.isCustom() && (
                'checkbox' === this.elem.nativeElement.getAttribute('type') ||
                'radio' === this.elem.nativeElement.getAttribute('type')
            )
        ) {
            this.formControlClass = false;
            this.formCheckInput = true;
        }

        this.makeReadonly();

        if (this.isCustom()) {
            this.formControlClass = false;
            this.formCheckInput = true;
        }
    }

    private makeReadonly(): void {
        if (!this.isReadonly()) {
            this.elem.nativeElement.removeAttribute('readonly');
            this.elem.nativeElement.removeAttribute('disabled');
            this.elem.nativeElement.classList.remove('form-control-plaintext');
            if ('TEXTAREA' === this.elem.nativeElement.nodeName) {
                this.elem.nativeElement.style.resize = '';
            }

            return;
        }

        if (this.formControlClass && !this.isCustom()) {
            this.elem.nativeElement.classList.add('form-control-plaintext');
        }

        this.elem.nativeElement.setAttribute('readonly', 'readonly');
        this.elem.nativeElement.setAttribute('disabled', 'disabled');
        if ('TEXTAREA' === this.elem.nativeElement.nodeName) {
            this.elem.nativeElement.style.resize = 'none';
        }
    }
}
